export const runIdle = (cb, timeout = 1000) => {
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(cb, { timeout });
  } else {
    setTimeout(cb, 0);
  }
};
